export default __webpack_public_path__ + "static/eftLanding-6884b57e50dc18ce97226609a4c1b906.png";